<template>
    <div>
        <!--Synchronizing state-->
        <loading :active.sync="isSynchronizing"
        :can-cancel="false" 
        :z-index='99999'
        :is-full-page="true">
        </loading>
        <!--./Synchronizing state-->
        <modal :show.sync="sendAssessment" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Ingrese su correo electrónico</h6>
                <div class="alert alert-info">
                    <span>La evaluación será enviada al soporte técnico para revisión. Ingrese un correo para obtener respuesta</span>
                </div>
                <div class="form-group">
                    <label>Correo electrónico *</label>
                    <fg-input   type="text"
                                name="correo"
                                placeholder="correo"
                                autocomplete="off"
                                v-validate="modelValidations.emailText"
                                :error="getError('correo')"
                                v-model="emailText">
                    </fg-input>
                </div>  
                <div class="form-group">
                    <label>Motivo de revisión *</label>
                    <fg-input   type="text"
                                name="motivo"
                                placeholder="motivo"
                                autocomplete="off"
                                v-validate="modelValidations.reason"
                                :error="getError('motivo')"
                                v-model="emailReason">
                    </fg-input>
                </div>    
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelSendAssessment()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="sendAssessmentMethod()">Enviar</p-button>
                </div>
            </template>
        </modal>
        <card v-if="validateCustomerAssesment()" key="customer-assesment" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title-orange">Cliente {{this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerFirstName}} {{this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSurname}}</h6>
            </div>
            <div class="card-body text-center">
                <card-dark v-for="(study,index) in $store.state.assesments[$store.state.actualAssesment].customer.studies" :key="index" class="form-horizontal">
                    <div v-if="validateStudy(study)" key="title-customer" class="card-header">
                        <h6 v-if="productValidator(study) == 'microcredit'" class="card-title-orange">Estudio {{index+1}} - {{studyName(study)}} - {{studySubcategory(study)}} - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'consumer'" class="card-title-orange">Estudio {{index+1}} - Consumo - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'pyme'" class="card-title-orange">Estudio {{index+1}} - Pequeña empresa - {{studyName(study)}} - {{studySubcategory(study)}} - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'agro'" class="card-title-orange">Estudio {{index+1}} - Agropecuario - ({{validateFinished(study)}})</h6>
                    </div>
                    <div v-else key="title-customer" class="card-header">
                        <h6 class="card-title-orange">Estudio {{index+1}} en proceso</h6>
                    </div>
                    <div v-if="validateStudy(study)" class="card-body text-center">
                        <div class="row">
                            <p-button  @click="continueStudy(index, 'customer')" type="block btn-warning">
                                Datos de solicitud
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button v-if="productValidator(study) == 'agro'" @click="toCashFlow(index, 'customer')" type="block btn-warning">
                                Datos flujo de caja
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroInventory(index, 'customer')" type="block btn-warning">
                                Inventario agrícola
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroEstate(index, 'customer')" type="block btn-warning">
                                Inmuebles
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroMachinery(index, 'customer')" type="block btn-warning">
                                Maquinaria y equipo
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toHistoricalYields(index, 'customer')" type="block btn-warning">
                                Rendimientos históricos
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroProduct(index, 'customer')" type="block btn-warning">
                                Ingresos por venta de productos almacenados
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroSeasonalSales(index, 'customer')" type="block btn-warning">
                                Ingresos por ventas estacionales
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroSalary(index, 'customer')" type="block btn-warning">
                                Ingresos por jornales - Salarios
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroExpenses(index, 'customer')" type="block btn-warning">
                                Egresos
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroLabour(index, 'customer')" type="block btn-warning">
                                Mano de obra
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroAnotherExpenses(index, 'customer')" type="block btn-warning">
                                Otros gastos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'agro'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toAgroFinancialObligationsData(index, 'customer')" type="block btn-warning">
                                Obligaciones financieras
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button v-if="index==0"  @click="toFM100(index, 'customer')" type="block btn-info">
                                Formulario FM100
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit' || productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toSalesData(study.studySubcategory, index, 'customer')" type="block btn-warning">
                                Ventas
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toCostsData(study.studySubcategory, index, 'customer')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeCostsData(study.studySubcategory, index, 'customer')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeSalariesData(study.studySubcategory, index, 'customer')" type="block btn-warning">
                                Salarios
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeFinancialObligationsData(study.studySubcategory, index, 'customer')" type="block btn-warning">
                                Obligaciones financieras
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) != 'agro'" class="row">
                            <p-button :disabled="validateSalesCostsData(study)" @click="toReferences(index, 'customer')" type="block btn-warning">
                                Referencias
                            </p-button>
                        </div>
                        <div v-if="validateAgroMicro('customer',index)" class="row">
                            <p-button :disabled="validateBalanceData(study)" @click="toBalanceData(index, 'customer')" type="block btn-warning">
                                Balance
                            </p-button>
                        </div>
                        <div v-if="validateCharacterAnalysis(study)" class="row">
                            <p-button :disabled="validateAnalysisData(study)" @click="toCharacterAnalysis(index, 'customer')" type="block btn-warning">
                                Análisis de caracter
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'agro'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toCashFlowFull(index, 'customer')" type="block btn-warning">
                                Flujo de caja
                            </p-button>
                        </div>
                        <div v-if="validateBalance(study) && validateFirstIsAgro('customer', index)" class="row">
                            <p-button :disabled="validateFinancialIndicators(study, index)" @click="toFinancialIndicators(index, 'customer')" type="block btn-warning">
                                Indicadores financieros
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toWillingnessToPay(study.studySubcategory, index, 'customer')" type="block btn-warning">
                                Evaluación cualitativa y de riesgo
                            </p-button>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <p-button @click="deleteStudy($store.state.actualAssesment, index, 'customer')" type="block btn-danger">
                                Eliminar estudio
                            </p-button>
                        </div>
                    </div>
                </card-dark>
                <div v-if="$store.state.assesments[$store.state.actualAssesment].customer.studies.length > 0">
                    <p-button @click="toFM102(0, 'customer')" type="block btn-info">
                        Formulario FM102
                    </p-button>
                </div>
                <div v-if="(($store.state.assesments[$store.state.actualAssesment].customer.studies.length > 1 && isCustomerConsolidated()) || isCustomerConsolidatedPyme())">
                    <p-button @click="toConsolidatedDataBalance()" type="block btn-success">
                        Balance consolidado
                    </p-button>
                </div>
                <!-- <div v-if="$store.state.assesments[$store.state.actualAssesment].finished">
                    <p-button @click="toAssessmentSync()" type="block btn-success">
                        Sincronizar evaluación
                    </p-button>
                </div> -->
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="validateSpouseAssesment()" key="spouse-assesment" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title-orange">Cónyuge {{this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName}} {{this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSurname}}</h6>
            </div>
            <div class="card-body text-center">
                <card-dark v-for="(study,index) in $store.state.assesments[$store.state.actualAssesment].customerSpouse.studies" :key="index" class="form-horizontal">
                    <div v-if="validateStudy(study)" key="title-customer" class="card-header">
                        <h6 v-if="productValidator(study) == 'microcredit'" class="card-title-orange">Estudio {{index+1}} - {{studyName(study)}} - {{studySubcategory(study)}} - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'consumer'" class="card-title-orange">Estudio {{index+1}} - Consumo - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'pyme'" class="card-title-orange">Estudio {{index+1}} - Pequeña empresa - {{studyName(study)}} - {{studySubcategory(study)}} - ({{validateFinished(study)}})</h6>
                    </div>
                    <div v-else key="title-customer" class="card-header">
                        <h6 class="card-title-orange">Estudio {{index+1}} en proceso</h6>
                    </div>
                    <div v-if="validateStudy(study)" class="card-body text-center">
                        <div class="row">
                            <p-button  @click="continueStudy(index, 'spouse')" type="block btn-warning">
                                Datos de solicitud
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit' || productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toSalesData(study.studySubcategory, index, 'spouse')" type="block btn-warning">
                                Ventas
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toCostsData(study.studySubcategory, index, 'spouse')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeCostsData(study.studySubcategory, index, 'spouse')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeSalariesData(study.studySubcategory, index, 'spouse')" type="block btn-warning">
                                Salarios
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeFinancialObligationsData(study.studySubcategory, index, 'spouse')" type="block btn-warning">
                                Obligaciones financieras
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button :disabled="validateSalesCostsData(study)" @click="toReferences(index, 'spouse')" type="block btn-warning">
                                Referencias
                            </p-button>
                        </div>
                        <div v-if="validateBalance(study)" class="row">
                            <p-button :disabled="validateBalanceData(study)" @click="toBalanceData(index, 'spouse')" type="block btn-warning">
                                Balance
                            </p-button>
                        </div>
                        <div v-if="validateCharacterAnalysis(study)" class="row">
                            <p-button :disabled="validateAnalysisData(study)" @click="toCharacterAnalysis(index, 'spouse')" type="block btn-warning">
                                Análisis de caracter
                            </p-button>
                        </div>
                        <div v-if="validateBalance(study)" class="row">
                            <p-button :disabled="validateFinancialIndicators(study, index)" @click="toFinancialIndicators(index, 'spouse')" type="block btn-warning">
                                Indicadores financieros
                            </p-button>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <p-button @click="deleteStudy($store.state.actualAssesment, index, 'spouse')" type="block btn-danger">
                                Eliminar estudio
                            </p-button>
                        </div>
                    </div>
                </card-dark>
                <!-- <div v-if="$store.state.assesments[$store.state.actualAssesment].customerSpouse.studies.length > 1">
                    <p-button @click="toConsolidatedDataBalance()" type="block btn-success">
                        Balance consolidado
                    </p-button>
                </div> -->
                <!-- <div v-if="$store.state.assesments[$store.state.actualAssesment].finished">
                    <p-button @click="toAssessmentSync()" type="block btn-success">
                        Sincronizar evaluación
                    </p-button>
                </div> -->
            </div>
            <div class="card-footer">
            </div>
        </card>
        <card v-if="validateGuarantorAssesment()" key="guarantor-assesment" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title-orange">Codeudor {{this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerFirstName}} {{this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerSurname}}</h6>
            </div>
            <div class="card-body text-center">
                <card-dark v-for="(study,index) in $store.state.assesments[$store.state.actualAssesment].guarantors[0].studies" :key="index" class="form-horizontal">
                    <div v-if="validateStudy(study)" key="title-customer" class="card-header">
                        <h6 v-if="productValidator(study) == 'microcredit'" class="card-title-orange">Estudio {{index+1}} - {{studyName(study)}} - {{studySubcategory(study)}} - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'consumer'" class="card-title-orange">Estudio {{index+1}} - Consumo - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'pyme'" class="card-title-orange">Estudio {{index+1}} - Pequeña empresa - {{studyName(study)}} - {{studySubcategory(study)}} - ({{validateFinished(study)}})</h6>
                        <h6 v-if="productValidator(study) == 'agro'" class="card-title-orange">Estudio {{index+1}} - Agropecuario - ({{validateFinished(study)}})</h6>
                    </div>
                    <div v-else key="title-customer" class="card-header">
                        <h6 class="card-title-orange">Estudio {{index+1}} en proceso</h6>
                    </div>
                    <div v-if="validateStudy(study)" class="card-body text-center">
                        <!-- <div class="row">
                            <p-button  @click="continueStudy(index, 'guarantor')" type="block btn-warning">
                                Datos de solicitud
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button v-if="index==0"  @click="toFM100(index, 'guarantor')" type="block btn-info">
                                Formulario FM100
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit' || productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toSalesData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Ventas
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toCostsData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeCostsData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeSalariesData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Salarios
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeFinancialObligationsData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Obligaciones financieras
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button :disabled="validateSalesCostsData(study)" @click="toReferences(index, 'guarantor')" type="block btn-warning">
                                Referencias
                            </p-button>
                        </div>
                        <div v-if="validateBalance(study)" class="row">
                            <p-button :disabled="validateBalanceData(study)" @click="toBalanceData(index, 'guarantor')" type="block btn-warning">
                                Balance
                            </p-button>
                        </div>
                        <div v-if="validateCharacterAnalysis(study)" class="row">
                            <p-button :disabled="validateAnalysisData(study)" @click="toCharacterAnalysis(index, 'guarantor')" type="block btn-warning">
                                Análisis de caracter
                            </p-button>
                        </div>
                        <div v-if="validateBalance(study)" class="row">
                            <p-button :disabled="validateFinancialIndicators(study, index)" @click="toFinancialIndicators(index, 'guarantor')" type="block btn-warning">
                                Indicadores financieros
                            </p-button>
                        </div> -->
                        <div class="row">
                            <p-button  @click="continueStudy(index, 'guarantor')" type="block btn-warning">
                                Datos de solicitud
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button v-if="productValidator(study) == 'agro'" @click="toCashFlow(index, 'guarantor')" type="block btn-warning">
                                Datos flujo de caja
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroInventory(index, 'guarantor')" type="block btn-warning">
                                Inventario agrícola
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroEstate(index, 'guarantor')" type="block btn-warning">
                                Inmuebles
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroMachinery(index, 'guarantor')" type="block btn-warning">
                                Maquinaria y equipo
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toHistoricalYields(index, 'guarantor')" type="block btn-warning">
                                Rendimientos históricos
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroProduct(index, 'guarantor')" type="block btn-warning">
                                Ingresos por venta de productos almacenados
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroSeasonalSales(index, 'guarantor')" type="block btn-warning">
                                Ingresos por ventas estacionales
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroSalary(index, 'guarantor')" type="block btn-warning">
                                Ingresos por jornales - Salarios
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroExpenses(index, 'guarantor')" type="block btn-warning">
                                Egresos
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroLabour(index, 'guarantor')" type="block btn-warning">
                                Mano de obra
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button  v-if="productValidator(study) == 'agro'" @click="toAgroAnotherExpenses(index, 'guarantor')" type="block btn-warning">
                                Otros gastos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'agro'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toAgroFinancialObligationsData(index, 'guarantor')" type="block btn-warning">
                                Obligaciones financieras
                            </p-button>
                        </div>
                        <div class="row">
                            <p-button v-if="index==0"  @click="toFM100(index, 'guarantor')" type="block btn-info">
                                Formulario FM100
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit' || productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toSalesData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Ventas
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'microcredit'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toCostsData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeCostsData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Costos
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeSalariesData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Salarios
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toPymeFinancialObligationsData(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Obligaciones financieras
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) != 'agro'" class="row">
                            <p-button :disabled="validateSalesCostsData(study)" @click="toReferences(index, 'guarantor')" type="block btn-warning">
                                Referencias
                            </p-button>
                        </div>
                        <div v-if="validateAgroMicro('guarantor',index)" class="row">
                            <p-button :disabled="validateBalanceData(study)" @click="toBalanceData(index, 'guarantor')" type="block btn-warning">
                                Balance
                            </p-button>
                        </div>
                        <div v-if="validateCharacterAnalysis(study)" class="row">
                            <p-button :disabled="validateAnalysisData(study)" @click="toCharacterAnalysis(index, 'guarantor')" type="block btn-warning">
                                Análisis de caracter
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'agro'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toCashFlowFull(index, 'guarantor')" type="block btn-warning">
                                Flujo de caja
                            </p-button>
                        </div>
                        <div v-if="validateBalance(study) && validateFirstIsAgro('guarantor', index)" class="row">
                            <p-button :disabled="validateFinancialIndicators(study, index)" @click="toFinancialIndicators(index, 'guarantor')" type="block btn-warning">
                                Indicadores financieros
                            </p-button>
                        </div>
                        <div v-if="productValidator(study) == 'pyme'" class="row">
                            <p-button :disabled="validateRequestData(study)" @click="toWillingnessToPay(study.studySubcategory, index, 'guarantor')" type="block btn-warning">
                                Evaluación cualitativa y de riesgo
                            </p-button>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <p-button @click="deleteStudy($store.state.actualAssesment, index, 'guarantor')" type="block btn-danger">
                                Eliminar estudio
                            </p-button>
                        </div>
                    </div>
                </card-dark>
            </div>
            <div class="card-footer">

            </div>
        </card>
        <card v-if="validateAlerts()" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title-orange">Alertas</h6>
            </div>
            <div class="card-body text-center">
                <card-dark>
                    <div v-if="$store.state.assesments[$store.state.actualAssesment].guarantors.length > 0 && $store.state.assesments[$store.state.actualAssesment].guarantors[0].customerFirstName == null && $store.state.assesments[$store.state.actualAssesment].guarantors[0].studies.length > 0" class="alert alert-info">
                        <span>Hemos detectado que existe un codeudor sin información personal pero con estudios, elimina el codeudor para poder sincronizar</span>
                    </div>
                    <p-button v-if="$store.state.assesments[$store.state.actualAssesment].guarantors.length > 0 && $store.state.assesments[$store.state.actualAssesment].guarantors[0].customerFirstName == null && $store.state.assesments[$store.state.actualAssesment].guarantors[0].studies.length > 0" @click="deleteStudy($store.state.actualAssesment, 0, 'guarantor')" type="block btn-danger">
                        Eliminar estudio de codeudor
                    </p-button>
                </card-dark>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <!--<card v-else key="guarantor-assesment" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">La información del codeudor no ha sido agregada completamente</h6>
            </div>
        </card>-->
        <div class="text-right">
            <p-button v-if="$store.state.assesments.length > 0 && $store.state.assesments[$store.state.actualAssesment].finished" @click="toAssessmentSync($store.state.actualAssesment)" type="success" class="mr-2">Sincronizar evaluación</p-button>
            <p-button @click="deleteAssesment($store.state.actualAssesment)" type="danger">Eliminar evaluación</p-button>
            <p-button @click="toBack()" type="default" class="pull-left mb-3">Atrás</p-button>
            <p-button @click="showSendAssessment()" type="danger" class="pull-left mb-3">Reportar error</p-button>
        </div>
        
    </div>
</template>
    <script>
    import Vue from 'vue'
    import SecureLS from 'secure-ls';
    import { Card, CardDark, Modal } from 'src/components/UIComponents'
    import swal from 'sweetalert2'
    import { isEmpty } from 'lodash';
    import { SEND_ERRORS } from 'src/api/graphql/mutations/share/SendReport';
    import { VERIFY_TOKEN } from 'src/api/graphql/mutations/auth/VerifyToken';
    import Loading from 'vue-loading-overlay';
    import axios from 'axios'
    export default {
        components: {
            Card,
            CardDark,
            Loading,
            Modal
        },
        data() {
            return {
                errorReport: {
                    query: '',
                    variables: '',
                    response: '',
                },
                microcredit: false,
                consumer: false,
                pyme: false,
                sendAssessment: false,
                emailText: '',
                emailReason: 'default',
                emailId: null,
                isSynchronizing: false,
                modelValidations: {
                emailText: {
                    required: true,
                    regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                },
                reason: {
                    required: true,
                    max: 128
                },
            },
            }
        },
        methods: {
            validateAgroMicro (person,index) {
                if(index > 0){
                    if (person == 'customer') {
                        const countStudies = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length;
                        if(countStudies > 1){
                            var firstProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                            if(firstProduct.name.toLowerCase() == 'agropecuario'){
                                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[index].productType)  
                                if(product.name.toLowerCase() == 'microcrédito'){
                                    return false
                                }
                                else {
                                    return true
                                }
                            }
                            else {
                                return true
                            }
                            
                        }
                        else {
                            return true
                        }
                    }
                    else {
                        return true
                    }
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateAlerts () {
                if(this.$store.state.assesments.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length != 0) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerFirstName == null && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].studies.length > 0) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            async sendAssessmentMethod () {
                var vm = this;
                let response = await vm.verifySession();
                if (response) {
                    vm.$validator.validateAll().then(isValid => {
                        if(isValid){
                            vm.errorReport.query = 'Envío de evaluación para revisión: '+vm.emailReason;
                            vm.errorReport.variables = JSON.stringify(vm.$store.state.assesments[vm.$store.state.actualAssesment]);
                            vm.errorReport.response = 'email: '+vm.emailText+'-{user: '+vm.$store.state.user.fullName+'}'+'-versión'+vm.$store.getters.appVersion;
                            vm.isSynchronizing = true;
                            vm.$apollo.mutate({
                                mutation: SEND_ERRORS,
                                variables : {
                                    input: vm.errorReport
                                }
                            }).then((data) => {
                                vm.isSynchronizing = false;
                                vm.sendAssessment = false;
                                vm.emailText = this.$store.getters.getUserEmail;
                                vm.emailReason = 'default';
                                vm.showNotificationSuccess('El reporte ha sido enviado al soporte técnico');
                            }).catch((error) => {
                                vm.isSynchronizing = false;
                                vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                            });     
                            
                        }
                    });
                }
                else {
                    vm.isSynchronizing = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');    
                }
            },
            /**
             * Función para ocultar la ventana que envía la hoja de trabajo.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelSendAssessment () {
                this.errors.clear();
                this.emailId = null;
                this.sendAssessment= false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifySession () {
                var vm = this;
                return new Promise(function(resolve, reject) {
                    var accessTokenDecoded = new SecureLS({encodingType: 'aes'});
                    var myToken = accessTokenDecoded.get('accessToken').data;
                    axios.defaults.headers.common["Authorization"] = 'Jwt '+myToken;
                    var refreshToken = accessTokenDecoded.get('refreshToken').data;
                    vm.$apollo.mutate({
                        mutation: VERIFY_TOKEN,
                        variables : {
                            input : {
                                token: myToken,
                            }
                        }
                    }).then((data) => {
                        resolve(true);
                    }).catch((error) => {
                        vm.isSynchronizing = false;
                        if(error.graphQLErrors.length > 0)
                        {
                            if (error.graphQLErrors[0].message == "Signature has expired") {
                                vm.$apollo.mutate({
                                    mutation: REFRESH_TOKEN,
                                    variables : {
                                        input : {
                                        refreshToken: refreshToken,
                                        }
                                    }
                                }).then((data) => {
                                    vm.$store.dispatch('updateToken',data.data.refreshToken).then(()=>{
                                        resolve(true);
                                    });
                                }).catch((error) => {
                                    resolve(false);
                                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');  
                                });
                            }
                        }
                        // else if (error.networkError) {
                        //     switch (error.networkError.statusCode) {
                        //         case 500:
                        //         vm.showNotificationError("Ha ocurrido un error en el servidor, contacte con el administrador del sistema");
                        //         resolve(false);
                        //         break


                        //         case 403:
                        //         if (error.networkError.bodyText == 'Cuenta bloqueada: demasiados intentos de inicio de sesión. Por favor, inténtelo de nuevo más tarde') {
                        //             vm.showNotificationError(error.networkError.bodyText);  
                        //         }
                        //         else {
                        //             vm.showNotificationError("La verificación de CSRF ha fallado. Recarga la página e intenta de nuevo");
                        //         }
                        //         resolve(false);
                        //         break
                                
                                
                        //         case 404:
                        //         vm.showNotificatishowNotificationError("El sistema actualmente está en mantenimiento, continúa trabajando en tu dispositivo y vuelve a sincronizar en un par de horas");
                        //         resolve(false);
                        //         break
                                
                        //         case undefined:
                        //         vm.showNotificationError("Ha ocurrido un error en el servidor, contacte con el administrador del sistema");
                        //         resolve(false);
                        //         break
                                
                        //         default:
                        //         vm.showNotificationError("Ha ocurrido un error en el servidor, contacte con el administrador del sistema");
                        //         resolve(false);
                        //         break
                        //     }
                        // }
                        else {
                            resolve(false);
                            vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');    
                        }
                    }); 
                });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showSendAssessment () {
                this.errors.clear();
                this.sendAssessment= true;
            },
            isCustomerConsolidatedPyme(){
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                if(product.name.toLowerCase() == 'pequeña empresa') {
                    const assessments = this.$store.state.assesments;
                    const actualAssesment = this.$store.state.actualAssesment;
                    const obj = assessments && assessments[actualAssesment] && assessments[actualAssesment].customerBalanceConsolidated;

                    if (obj && Object.keys(obj).length > 0) {
                        // El objeto no está vacío
                        return true
                        
                    } else {
                        // Es un objeto vacío o no está definido
                        return false
                    }
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            isCustomerConsolidated(){
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                if(product.name.toLowerCase() == 'consumo') {
                    var secondProduct = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[1].productType)
                    if(secondProduct.name.toLowerCase() == 'microcrédito' || secondProduct.name.toLowerCase() == 'microcredito') {
                        return false
                    }
                    else {
                        return true
                    }
                }
                else if(product.name.toLowerCase() == 'agropecuario'){
                    return false
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (study) {
                if (study.productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == study.productType)
                    var response = '';
                    if(product.name.toLowerCase() == 'consumo') {
                        response = 'consumer';
                    }
                    else if(product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        response = 'microcredit';
                    }
                    else if(product.name.toLowerCase() == 'pequeña empresa') {
                        response = 'pyme';
                    }
                    else if(product.name.toLowerCase() == 'agropecuario') {
                        response = 'agro';
                    }
                    return response
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidatorId (studyId, person) {
                if (person == 'customer') {
                    var study = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[studyId];
                }
                else if (person == 'spouse') {
                    var study = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[studyId];
                }
                else if (person == 'guarantor') {
                    var study = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].studies[studyId];
                }
                if (study.productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == study.productType)
                    var response = '';
                    if(product.name.toLowerCase() == 'consumo') {
                        response = 'consumer';
                    }
                    else if(product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        response = 'microcredit';
                    }
                    else if(product.name.toLowerCase() == 'pequeña empresa') {
                        response = 'pyme';
                    }
                    else if(product.name.toLowerCase() == 'agropecuario') {
                        response = 'agro';
                    }
                    return response
                }
            },
            validateRequestData (study) {
                if (this.productValidator(study) == 'microcredit' || this.productValidator(study) == 'pyme') {
                    if (study.productType != null &&
                        this.$store.state.assesments[this.$store.state.actualAssesment].creditType != null &&
                        this.$store.state.assesments[this.$store.state.actualAssesment].creditPurpose != null &&
                        this.$store.state.assesments[this.$store.state.actualAssesment].amount != 0 &&
                        this.$store.state.assesments[this.$store.state.actualAssesment].amount && 
                        study.studyActivity != null &&
                        study.studySubcategory != null) {
                        return false
                    }
                    else {
                        return true
                    }
                }
                else if (this.productValidator(study) == 'consumer'){
                    if (study.productType != null &&
                        this.$store.state.assesments[this.$store.state.actualAssesment].creditType != null &&
                        this.$store.state.assesments[this.$store.state.actualAssesment].creditPurpose != null &&
                        this.$store.state.assesments[this.$store.state.actualAssesment].amount != 0 && 
                        this.$store.state.assesments[this.$store.state.actualAssesment].salary != 0) {
                        return false
                    }
                    else {
                        return true
                    }
                }
            },
            validateSalesCostsData (study) {
                if (this.productValidator(study) == 'microcredit' || this.productValidator(study) == 'pyme') {
                    if (study.salesPopulate && study.costsPopulate) {
                        return false
                    } else {
                        return true
                    }
                }
                else if (this.productValidator(study) == 'consumer') {
                    if (!this.validateRequestData(study)) {
                        return false
                    }
                    else {
                        return true
                    }
                }
                
            },
            validateSalesData (study) {
                if (study.salesPopulate) {
                    false
                } else {
                    return true
                }
            },
            validateCostsData (study) {
                if (study.costsPopulate) {
                    false
                } else {
                    return true
                }
            },
            validateReferencesData(study) {
                if (study.references.length > 0) {
                    false
                } else {
                    return false
                }
            },
            validateBalanceData (study) {
                if (this.productValidator(study) == 'microcredit' || this.productValidator(study) == 'pyme') {
                    if (!this.validateSalesCostsData(study) && !this.validateReferencesData(study)) {
                        return false
                    } else {
                        return true
                    }
                }
                else {
                    if (!this.validateRequestData(study) && !this.validateReferencesData(study)) {
                        return false
                    } else {
                        return true
                    }
                }
                
            },
            validateAnalysisData(study) {
                if (!this.validateBalanceData(study) && this.validateBalance(study)) {
                    return false
                }
                else {
                    return true
                }
            },
            validateFinancialIndicators(study, index) {
                if (index == 0) {
                    if (!this.validateAnalysisData(study) && study.characterAnalysis.length > 0) {
                        return false
                    }
                    else {
                        return true
                    }
                }
                else {
                    if (!this.validateAnalysisData(study)) {
                        return false
                    }
                    else {
                        return true
                    }
                }
            },
            toAssessmentSync(assessment) {
                var vm = this;
                this.$store.dispatch('finishEvaluation', 'menu').then(()=>{
                    this.$router.push('/asessments/new_asessment/customer/others/assesment_sync');
                });
            },
            toBack () {
                if (this.$store.state.beforePathMenu != null) {
                    this.$router.push(this.$store.state.beforePathMenu);
                }
                else {
                    this.$router.push('/');
                }
                
            },
            studyName (study) {
                if(study.studyActivity != '' && study.studyActivity != null) {
                    let found = this.$store.getters.getActivityTypes.find(element => element.id == study.studyActivity);
                    return found.name
                }
                else {
                    return ''
                }
            },
            studySubcategory (study) {
                if (study.studySubcategory == 'general') {
                    return 'General'
                }
                else if (study.studySubcategory == 'catalogo')
                {
                    return 'Catálogo'
                }
                else if (study.studySubcategory == 'serviciogeneral')
                {
                    return 'General'
                }
                else if (study.studySubcategory == 'transporte')
                {
                    return 'Transporte'
                }
                else {
                    return 'Producción'
                }
            },
            validateFinished (study) {
                if (study.finished) {
                    return 'Finalizado'
                }
                else {
                    return 'Pendiente'
                }
            },
            validateStudy (study) {
                var consumer = false;
                var microcredit = false;
                var agro = false;
                if (study.productType != null) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == study.productType)
                    if(product.name.toLowerCase() == 'consumo') {
                        consumer = true;
                        microcredit = false;
                        agro = false;
                    }
                    else if(product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        microcredit = true;
                        consumer = false;
                        agro = false;
                    }
                    else if(product.name.toLowerCase() == 'pequeña empresa') {
                        microcredit = true;
                        consumer = false;
                        agro = false;
                    }
                    else if(product.name.toLowerCase() == 'agropecuario') {
                        microcredit = false;
                        consumer = false;
                        agro = true;
                    }
                }
                if (microcredit) {
                    if (study.studyActivity != null && study.studySubcategory != null) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else if (consumer) {
                    if (study.salary != null) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else if (agro) {
                    return true
                }
                
            },
            validateBalance (study) {
                if (study.balance.length != 0) {
                    return true
                }
                else {
                    return false
                }
            },
            validateFirstIsAgro (person, index){
                if(index > 0) {
                    if(person == 'customer'){
                        var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                    }
                    else if(person == 'spouse'){
                        var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].productType)
                    }
                    else if(person == 'guarantor'){
                        var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].productType)
                    }
                    if(product.name.toLowerCase() == 'agropecuario'){
                        return false
                    }
                }
                else {
                    return true
                }
            },
            validateCustomerAssesment () {
                if (this.$store.state.assesments.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerFirstName != null && this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationNumber != null && this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationType != null) {
                    return true
                }
                else {
                    return false
                }    
            },
            validateSpouseAssesment () {
                if (this.$store.state.assesments.length > 0) {
                    if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse !== 'undefined' && !_.isEmpty(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse)) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName != null && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationNumber != null && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationType != null) {
                            return true
                        }
                        else {
                            return false
                        }
                    }
                    else {
                        return false
                    }
                    
                }
                else {
                    return false
                }    
            },
            validateGuarantorAssesment () {
                if(this.$store.state.assesments.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length != 0) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerFirstName != null || this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerIdentificationNumber != null || this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerIdentificationType != null) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }    
            },
            toConsolidatedDataBalance() {
                var vm = this;
                var studies =  vm.$store.state.assesments[this.$store.state.actualAssesment].customer.studies.length;
                var flag = 0;
                for (let i=0; i<studies;i++) {
                    if (vm.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[i].finished == false) {
                        vm.showNotificationError('El estudio '+(i+1)+' no ha sido finalizado aún');
                        return
                    }
                }
                var payload = {
                    client: 'customer',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: 0
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/others/additional_information_consolidated');
                    });                    
                });
                
            },
            toGuarantorConsolidatedDataBalance(studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/guarantor/others/additional_information_consolidated');
                    });                    
                });
                
            },
            toBalanceData(studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        if (this.productValidatorId(studyId, person) == 'microcredit' || this.productValidatorId(studyId, person) == 'pyme') {
                            vm.$router.push('/asessments/new_asessment/customer/others/additional_information');
                        }
                        else if (this.productValidatorId(studyId, person) == 'consumer') {
                            vm.$router.push('/asessments/new_asessment/customer/others/consumer_additional_information');
                        }
                        else {
                            vm.$router.push('/asessments/new_asessment/customer/others/additional_information');
                        }
                        
                    });                    
                });  
            },
            toGuarantorBalanceData(studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/guarantor/others/additional_information');
                    });                    
                });  
            },
            toSalesData(subcategory, studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        if (subcategory == 'catalogo') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                        }
                        else {
                            vm.$router.push('/asessments/new_asessment/customer/sales');
                        }
                    });                    
                });
                
            },
            toGuarantorSalesData(subcategory, studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        if (subcategory == 'catalogo') {
                            vm.$router.push('/asessments/new_asessment/guarantor/costs/business/catalog');
                        }
                        else {
                            vm.$router.push('/asessments/new_asessment/guarantor/sales');
                        }
                    });                    
                });
                
            },
            toCostsData(subcategory, studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        if (subcategory == 'catalogo') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                        }
                        else if (subcategory == 'general') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/business/general');
                        }
                        else if (subcategory == 'produccion') {
                            vm.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                        }
                        else if (subcategory == 'serviciogeneral') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/services/general');
                        }
                        else if (subcategory == 'transporte') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/services/transport');
                        } 
                    });                    
                });
            },
            toPymeCostsData(subcategory, studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        if (subcategory == 'general') {
                            this.$router.push('/asessments/new_asessment/customer/pyme_general_costs_selection');
                        }
                        else if (subcategory == 'produccion') {
                            vm.$router.push('/asessments/new_asessment/customer/costs_item_general_selection');
                        }
                        else if (subcategory == 'transporte') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/services/pyme-transport');
                        } 
                        else if (subcategory == 'serviciogeneral') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/services/general');
                        }
                        else if (subcategory == 'catalogo') {
                            vm.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                        }
                    });                    
                });
            },
            toPymeSalariesData(subcategory, studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/salary');
                    });                    
                });
            },
            toPymeFinancialObligationsData(subcategory, studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/financial-obligations');
                    });                    
                });
            },
            toWillingnessToPay(subcategory, studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/others/willingness_to_pay');
                    });                    
                });
            },
            toGuarantorCostsData(subcategory, studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        if (subcategory == 'catalogo') {
                            vm.$router.push('/asessments/new_asessment/guarantor/costs/business/catalog');
                        }
                        else if (subcategory == 'general') {
                            vm.$router.push('/asessments/new_asessment/guarantor/costs/business/general');
                        }
                        else if (subcategory == 'produccion') {
                            vm.$router.push('/asessments/new_asessment/guarantor/costs_item_general_selection');
                        }
                        else if (subcategory == 'serviciogeneral') {
                            vm.$router.push('/asessments/new_asessment/guarantor/costs/services/general');
                        }
                        else if (subcategory == 'transporte') {
                            vm.$router.push('/asessments/new_asessment/guarantor/costs/services/transport');
                        } 
                    });                    
                });
            },
            toReferences (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/others/business_references');
                    });                    
                });
            },
            toGuarantorReferences (studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/guarantor/others/business_references');
                    });                    
                });
            },
            validateCharacterAnalysis (study) {
                if (study.characterAnalysis.length != 0) {
                    return true
                }
                else {
                    return false
                }
            },
            toFinancialIndicators (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        if (this.productValidatorId(studyId, person) == 'microcredit' || this.productValidatorId(studyId, person) == 'pyme' || this.productValidatorId(studyId, person) == 'agro') {
                            vm.$router.push('/asessments/new_asessment/customer/others/financial_indicators');
                        }
                        else if(this.productValidatorId(studyId, person) == 'consumer') {
                            vm.$router.push('/asessments/new_asessment/customer/others/financial_indicators_consumer');
                        }
                        
                    });                    
                });
            },
            toGuarantorFinancialIndicators (studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/guarantor/others/financial_indicators');
                    });                    
                });
            },
            toCharacterAnalysis (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/others/character_analysis');
                    });                    
                });
            },
            toGuarantorCharacterAnalysis (studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', true).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/guarantor/others/character_analysis');
                    });                    
                });
            },
            toCashFlow (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/cash_flow');
                    });                    
                });
            },
            toAgroInventory (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/inventory');
                    });                    
                });
            },
            toAgroEstate (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/estate');
                    });                    
                });
            },
            toAgroMachinery (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/machinery');
                    });                    
                });
            },
            toHistoricalYields (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/historical_yields');
                    });                    
                });
            },
            toAgroProduct (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/product');
                    });                    
                });
            },
            toAgroSalary (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/salary');
                    });                    
                });
            },
            toAgroExpenses (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/expenses');
                    });                    
                });
            },
            toAgroLabour (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/labour');
                    });                    
                });
            },
            toAgroAnotherExpenses (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/another_expenses');
                    });                    
                });
            },
            toAgroFinancialObligationsData (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/financial_obligations');
                    });                    
                });
            },
            toCashFlowFull (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/cash_flow');
                    });                    
                });
            },
            toAgroSeasonalSales (studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/agro/seasonal_sales');
                    });                    
                });
            },
            continueStudy(studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/request_data');
                    });                    
                });
            },
            toFM100(studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/fm100');
                    });                    
                });
            },
            toFM102(studyId, person) {
                var vm = this;
                if (person == 'customer') {
                    var payload = {
                        client: 'customer',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'spouse'){
                    var payload = {
                        client: 'spouse',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                else if (person == 'guarantor'){
                    var payload = {
                        client: 'guarantor',
                        actualAssesment: vm.$store.state.actualAssesment,
                        actualStudy: studyId
                    }
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/customer/fm102');
                    });                    
                });
            },
            continueGuarantorStudy(studyId) {
                var vm = this;
                var payload = {
                    client: 'guarantor',
                    actualAssesment: vm.$store.state.actualAssesment,
                    actualStudy: studyId
                }
                vm.$store.dispatch('setAssesmentEdit', false).then(()=>{
                    vm.$store.dispatch('setActualAssesmentStudy', payload).then(()=>{
                        vm.$router.push('/asessments/new_asessment/guarantor/request_data');
                    });                    
                });
            },
            deleteStudy(assesmentId, studyId, person) {
                let agro = false;
                if(studyId > 0 && person == 'customer') {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                    if(product.name.toLowerCase() == 'agropecuario'){
                        agro = true
                    }
                }
                else if(person == 'spouse'){
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
                    if(product.name.toLowerCase() == 'agropecuario'){
                        agro = true
                    }
                }
                var payload = {
                    client: '',
                    assesment_id: null,
                    study_id: null,
                    deleteAgro: agro
                };
                payload.client = person;
                payload.assesment_id = assesmentId;
                payload.study_id = studyId;
                var vm = this;
                swal({
                    title: '¿Está seguro?',
                    text: 'Está a punto de eliminar un estudio',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, continuar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    vm.$store.dispatch('deleteCustomerStudy', payload).then(()=>{
                        if(person == 'customer') {
                            if (vm.$store.state.assesments[assesmentId].customer.studies.length > 0) {
                                swal({
                                    title: 'Correcto',
                                    text: 'El estudio ha sido eliminado correctamente',
                                    type: 'success',
                                    showCancelButton: false,
                                    confirmButtonText: 'Aceptar',
                                    confirmButtonClass: 'btn btn-success btn-fill',
                                    buttonsStyling: false
                                })
                                .then(() => {vm.$router.go();},
                                function (dismiss) {
                                    vm.$router.go();
                                })
                            } 
                            else {
                                vm.$store.dispatch('deleteAssesment', assesmentId).then(()=>{
                                    vm.$router.push('/')
                                });
                            }
                        }
                        else if(person == 'guarantor') {
                            swal({
                                title: 'Correcto',
                                text: 'El estudio ha sido eliminado correctamente',
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'Aceptar',
                                confirmButtonClass: 'btn btn-success btn-fill',
                                buttonsStyling: false
                            })
                            .then(() => {vm.$router.go();},
                             function (dismiss) {
                                vm.$router.go();
                            })
                        }
                        else if(person == 'spouse') {
                            swal({
                                title: 'Correcto',
                                text: 'El estudio ha sido eliminado correctamente',
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'Aceptar',
                                confirmButtonClass: 'btn btn-success btn-fill',
                                buttonsStyling: false
                            })
                            .then(() => {vm.$router.go();},
                             function (dismiss) {
                                vm.$router.go();
                            })
                        }
                    });
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'No se ha eliminado el estudio',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                })
            },
            deleteGuarantorStudy(assesmentId, studyId) {
                var payload = {
                    assesment_id: null,
                    study_id: null
                };
                payload.assesment_id = assesmentId;
                payload.study_id = studyId;
                var vm = this;
                swal({
                    title: '¿Está seguro?',
                    text: 'Está a punto de eliminar un estudio',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, continuar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    vm.$store.dispatch('deleteGuarantorStudy', payload).then(()=>{
                        swal({
                            title: 'Correcto',
                            text: 'El estudio ha sido eliminado correctamente',
                            type: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'Aceptar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            buttonsStyling: false
                        })
                    });
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'No se ha eliminado el estudio',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            deleteAssesment(assesmentId) {
                var vm = this;
                swal({
                    title: '¿Está seguro?',
                    text: 'Está a punto de eliminar la evaluación',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Si, continuar',
                    cancelButtonText: 'No, cancelar',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    buttonsStyling: false
                }).then(() => {
                    vm.$store.dispatch('deleteAssesment', assesmentId).then(()=>{
                        // vm.$router.push(vm.$store.state.beforePathMenu)
                        vm.$router.push('/')
                    });
                }, function (dismiss) {
                    // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                    swal({
                        title: 'Cancelado',
                        text: 'No se ha eliminado la evaluación',
                        type: 'error',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        buttonsStyling: false
                    })
                })
            },
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            emailId: function(newVal) {
                this.studyId = newVal;
            }
        },
        mounted() {
            // Con la siguiente función evitamos que el usuario pueda retroceder en el historial del navegador
            history.pushState(null, null, location.href);
            window.onpopstate = function () {
                history.go(1);
            };
            this.$store.state.isCustomer = false;
            this.$store.state.isSpouse = false;
            this.$store.state.isGuarantor = false;
        }
    }
</script>
<style>
</style>
